import { Directive, ComponentFactoryResolver, ComponentRef, ViewContainerRef, OnInit, Input, output } from '@angular/core';

import { StudioMultiProductTemplateComponent } from '../components/studio-multi-product-template/studio-multi-product-template.component';
import { StudioNslaTemplateComponent } from '../components/studio-nsla/studio-nsla-template.component';
import { StudioSingleProductTemplateComponent } from '../components/studio-single-product-template/studio-single-product-template.component';
import { StudioSliderTemplateComponent } from '../components/studio-slider-template/studio-slider-template.component';
import { Studiot4sComponent } from '../components/studio-t4s/studio-t4s.component';
import { StudioTemplatesComponent } from '../components/studio-templates/studio-templates.component';
import { StudioTemplatesService } from '../services/studio-templates.service';

import { ProductPublicModels } from '@features/products/product';
import { CategoryConfiguration, ProductViewPlace } from '@shared/product/models';

// TODO ECOMDUTI-24683 [TechDebt] - No se deben cargar todos los templates en el bundle
const components = {
    CC: StudioTemplatesComponent,
    '1LE': StudioMultiProductTemplateComponent,
    '2FV': StudioMultiProductTemplateComponent,
    '3A': StudioMultiProductTemplateComponent,
    '4A': StudioMultiProductTemplateComponent,
    '4B': StudioMultiProductTemplateComponent,
    '4B_0': StudioMultiProductTemplateComponent,
    '4B_1': StudioMultiProductTemplateComponent,
    SEPARATOR_12_5: StudioSingleProductTemplateComponent,
    SEPARATOR_25: StudioSingleProductTemplateComponent,
    SEPARATOR_50: StudioSingleProductTemplateComponent,
    SEPARATOR_SM: StudioSingleProductTemplateComponent,
    SEPARATOR_MD: StudioSingleProductTemplateComponent,
    SEPARATOR_LG: StudioSingleProductTemplateComponent,
    SEPARATOR_XL: StudioSingleProductTemplateComponent,
    FIV: StudioSingleProductTemplateComponent,

    // TEMPLATES SIN TRASPASAR AL NUEVO SISTEMA
    '4S': Studiot4sComponent,

    // NUEVOS TEMPLATES 2024
    N1A_0: StudioTemplatesComponent,
    N1A_1: StudioTemplatesComponent,
    N1A_2: StudioTemplatesComponent,
    N1C_0: StudioTemplatesComponent,
    N1C_1: StudioTemplatesComponent,
    N1C_2: StudioTemplatesComponent,
    N1F_0: StudioTemplatesComponent,
    N1F_1: StudioTemplatesComponent,
    N1F_2: StudioTemplatesComponent,
    N1E_0: StudioTemplatesComponent,
    N1E_1: StudioTemplatesComponent,
    N1E_2: StudioTemplatesComponent,
    N1H_0: StudioTemplatesComponent,
    N1H_1: StudioTemplatesComponent,
    N1H_2: StudioTemplatesComponent,
    N1J_0: StudioTemplatesComponent,
    N1J_1: StudioTemplatesComponent,
    N1J_2: StudioTemplatesComponent,
    N1B_0: StudioTemplatesComponent,
    N1B_1: StudioTemplatesComponent,
    N1B_2: StudioTemplatesComponent,
    N1D_0: StudioTemplatesComponent,
    N1D_1: StudioTemplatesComponent,
    N1D_2: StudioTemplatesComponent,
    N2A_0: StudioTemplatesComponent,
    N2A_1: StudioTemplatesComponent,
    N2A_2: StudioTemplatesComponent,
    N2C_0: StudioTemplatesComponent,
    N2C_1: StudioTemplatesComponent,
    N2C_2: StudioTemplatesComponent,
    N2G_0: StudioTemplatesComponent,
    N2G_1: StudioTemplatesComponent,
    N2G_2: StudioTemplatesComponent,

    N2E_0: StudioTemplatesComponent,
    N2E_1: StudioTemplatesComponent,
    N2E_2: StudioTemplatesComponent,
    N2H_0: StudioTemplatesComponent,
    N2H_1: StudioTemplatesComponent,
    N2H_2: StudioTemplatesComponent,
    N3D_0: StudioTemplatesComponent,
    N3D_1: StudioTemplatesComponent,
    N3D_2: StudioTemplatesComponent,
    N3F_0: StudioTemplatesComponent,
    N3F_1: StudioTemplatesComponent,
    N3F_2: StudioTemplatesComponent,
    N4G_0: StudioTemplatesComponent,
    N4G_1: StudioTemplatesComponent,
    N4G_2: StudioTemplatesComponent,
    N4K_0: StudioTemplatesComponent,
    N4K_1: StudioTemplatesComponent,
    N4K_2: StudioTemplatesComponent,
    N4L_0: StudioTemplatesComponent,
    N4L_1: StudioTemplatesComponent,
    N4L_2: StudioTemplatesComponent,
    N4M_0: StudioTemplatesComponent,
    N4M_1: StudioTemplatesComponent,
    N4M_2: StudioTemplatesComponent,
    N4N_0: StudioTemplatesComponent,
    N4N_1: StudioTemplatesComponent,
    N4N_2: StudioTemplatesComponent,

    N3G_0: StudioTemplatesComponent,
    N3G_1: StudioTemplatesComponent,
    N3G_2: StudioTemplatesComponent,
    N3H_0: StudioTemplatesComponent,
    N3H_1: StudioTemplatesComponent,
    N3H_2: StudioTemplatesComponent,
    N3J_0: StudioTemplatesComponent,
    N3J_1: StudioTemplatesComponent,
    N3L_0: StudioTemplatesComponent,
    N3L_1: StudioTemplatesComponent,
    N3K_0: StudioTemplatesComponent,
    N3K_1: StudioTemplatesComponent,
    N3M_0: StudioTemplatesComponent,
    N3M_1: StudioTemplatesComponent,
    N3M_2: StudioTemplatesComponent,
    N3N_0: StudioTemplatesComponent,
    N3N_1: StudioTemplatesComponent,
    N3N_2: StudioTemplatesComponent,
    N3P_0: StudioTemplatesComponent,
    N3P_1: StudioTemplatesComponent,
    N3P_2: StudioTemplatesComponent,
    N4A_0: StudioTemplatesComponent,
    N4A_1: StudioTemplatesComponent,
    N4A_2: StudioTemplatesComponent,
    N4E_2: StudioTemplatesComponent,
    N4J_0: StudioTemplatesComponent,
    N4J_1: StudioTemplatesComponent,
    N4J_2: StudioTemplatesComponent,
    N4H_0: StudioTemplatesComponent,
    N4H_1: StudioTemplatesComponent,
    N4H_2: StudioTemplatesComponent,
    N4F_2: StudioTemplatesComponent,
    NCB: StudioSliderTemplateComponent,
    LS1_0: StudioSliderTemplateComponent,
    LS1_1: StudioSliderTemplateComponent,
    LS1_2: StudioSliderTemplateComponent,
    LS2_0: StudioSliderTemplateComponent,
    LS2_1: StudioSliderTemplateComponent,
    LS2_2: StudioSliderTemplateComponent,
    NSLA: StudioNslaTemplateComponent,
    NSLB_0: StudioNslaTemplateComponent,
    NSLB_1: StudioNslaTemplateComponent,
    NSLB_2: StudioNslaTemplateComponent,
    Monox3_0: StudioTemplatesComponent,
    Monox3_1: StudioTemplatesComponent,
    Monox3_2: StudioTemplatesComponent,
    Monox4_0: StudioTemplatesComponent,
    Monox4_1: StudioTemplatesComponent,
    Monox4_2: StudioTemplatesComponent,
};
export const TestListComponentsStudio = components;

@Directive({
    selector: '[dynamicTemplateSelector]',
})

/**
 * Directiva la renderizar campos de formularios
 */
export class StudioTemplateDirective implements OnInit {
    @Input() public templateName: string;

    @Input() public categoryId: string;

    @Input() public products: ProductPublicModels.PublicProduct[];

    @Input() public categoryConfiguration: CategoryConfiguration;

    @Input() public place: ProductViewPlace;

    @Input() public elementIndex: number;

    @Input() public elementDefaultImageTypes: Map<number, string>;

    @Input() public isMediaCarouselActivated: boolean;

    @Input() public defaultTemplateAttachment: boolean;

    public readonly clickAddToCart = output<ProductPublicModels.PublicProduct>();

    public component: ComponentRef<any>;

    constructor(
        public container: ViewContainerRef,
        // eslint-disable-next-line deprecation/deprecation
        private readonly resolver: ComponentFactoryResolver,
    ) {}

    public ngOnInit(): void {
        this.loadComponent();
    }

    /**
     * Carga el componente correspondiente al tipo de campo que le pasamos
     */
    private loadComponent(): void {
        if (this.templateName) {
            const templateComponent = components[this.templateName] ? components[this.templateName] : components.CC;
            const component = this.resolver.resolveComponentFactory<any>(templateComponent);
            // eslint-disable-next-line deprecation/deprecation
            this.component = this.container.createComponent(component);
            this.component.instance.products = this.products;
            this.component.instance.categoryConfiguration = this.categoryConfiguration;
            this.component.instance.categoryId = this.categoryId;
            this.component.instance.templateName = this.templateName && components[this.templateName] ? this.templateName : 'CC';
            this.component.instance.place = this.place;
            this.component.instance.elementIndex = this.elementIndex;
            this.component.instance.elementDefaultImageTypes = this.elementDefaultImageTypes;
            this.component.instance.clickAddToCart = this.clickAddToCart;
            this.component.instance.isMediaCarouselActivated = this.isMediaCarouselActivated;
            this.component.instance.defaultTemplateAttachment = this.defaultTemplateAttachment;
            this.component.instance.productStyle = StudioTemplatesService.setProductStyle(
                this.categoryConfiguration,
                this.products
            );
        }
    }
}
